// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"260":"2de7b1e0","377":"41c95618","962":"41c95618"}[chunkId] + ".chunk.css";
};